export const otherPhoneWarning = "Please enter a valid phone number (XXX)XXX-XXXX";
